
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/faith-based",
      function () {
        return require("private-next-pages/use-cases/faith-based.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/faith-based"])
      });
    }
  